import React from 'react'
import { observer } from 'mobx-react-lite'

import { useTheme } from '@mui/material/styles'
import Stack from '@mui/material/Stack'

import { useGlobalStore } from '..'

export const Banner = observer(() => {
  const theme = useTheme()
  const {
    appDataStore: { banner, loadBanner, user },
  } = useGlobalStore()

  React.useEffect(() => {
    loadBanner().finally()
  }, [user])

  if (!banner?.image_url) {
    return null
  }

  return (
    <Stack
      sx={{
        alignItems: 'center',
        width: '100%',
        mb: 24,
      }}
    >
      <a
        aria-label="Banner"
        href={banner?.redirect_url}
        rel="noreferrer"
        style={{
          width: '100%',
        }}
        target="_blank"
      >
        <img
          alt=""
          src={banner.image_url}
          style={{
            width: '100%',
            height: 'auto',
            border: `1px solid ${theme.palette.grey['300']}`,
          }}
        />
      </a>
    </Stack>
  )
})
